import { render, staticRenderFns } from "./wl-upload.vue?vue&type=template&id=36722324&scoped=true&lang=pug"
import script from "./wl-upload.js?vue&type=script&lang=js&external"
export * from "./wl-upload.js?vue&type=script&lang=js&external"
import style0 from "./wl-upload.styl?vue&type=style&index=0&id=36722324&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36722324",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\G\\YT\\mes-project-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36722324')) {
      api.createRecord('36722324', component.options)
    } else {
      api.reload('36722324', component.options)
    }
    module.hot.accept("./wl-upload.vue?vue&type=template&id=36722324&scoped=true&lang=pug", function () {
      api.rerender('36722324', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wl-component-gallery/wl-upload/wl-upload.vue"
export default component.exports